import React from "react";
import { Box, Snackbar, Alert } from "@mui/material";
import useTechnicalAssessment from "./useTechnicalAssessment";
import StartAssessmentPage from "./StartAssessmentPage";
import AssessmentHeader from "./AssessmentHeader";
import AssessmentQuestionSection from "./AssessmentQuestionSection";
import CodeEditorSection from "./CodeEditorSection";
import GuidelinesDialogBox from "../../../components/common-components/technical-assessment/GuidelinesDialogBox";
import ConfirmSubmissionDialogBox from "../../../components/common-components/technical-assessment/ConfirmSubmissionDialogBox";
import EnablingCameraMessageDialog from "../../../components/common-components/technical-assessment/EnablingCameraMessageDialog";
import InterviewFullScreenDilogue from "../interview/InterviewFullScreenDilogue";
import InterviewStatusDialogue from "../../../components/common-components/InterviewStatusDilogueBox";
import EmailOTPVerification from "../../../components/common-components/EmailOTPVerification";
import FullScreenLoader from "../../../components/common-components/FullScreenLoader";
import { AssessmentPageWrapper, AssessmentBodyWrapper } from "./style";

const TechnicalAssessmentTest = () => {
  const {
    interviewDetail,
    apiQuestions,
    currentQuestion,
    currentQ,
    currentCode,
    savedQuestions,
    interviewStarted,
    agreed,
    setAgreed,
    globalTimeLeft,
    formatTime,
    isSubmitting,
    interviewStatus,
    canStartInterview,
    countdownText,
    openGuidelinesDialog,
    setOpenGuidelinesDialog,
    showFullScreenDialog,
    isInterviewSubmitted,
    statusDialogTitle,
    statusDialogMessage,
    faceMessage,
    showFaceDialog,
    localVideoRef,
    handleStartTest,
    handleEnterFullScreen,
    handleCodeChange,
    handleSave,
    handleNext,
    handlePrevious,
    handleQuestionClick,
    handleConfirmSubmit,
    handleSubmit,
    openSubmitDialog,
    setOpenSubmitDialog,
    tabSwitchWarning,
    setTabSwitchWarning,
    isOtpVerified,
    maskedEmail,
    candidateName,
    otpErrorMsg,
    handleSendOTP,
    handleVerifyOTP,
    isValidationPending,
    isSendOtpPending,
    isValidatePending,
  } = useTechnicalAssessment();

  if (isInterviewSubmitted) {
    return (
      <InterviewStatusDialogue
        open={true}
        title={statusDialogTitle}
        message={statusDialogMessage}
      />
    );
  }

  if (!isOtpVerified) {
    return (
      <EmailOTPVerification
        maskedEmail={maskedEmail}
        candidateName={candidateName}
        onSendOTP={handleSendOTP}
        onVerifyOTP={handleVerifyOTP}
        isSendingOTP={isSendOtpPending}
        isVerifyingOTP={isValidatePending}
        errorMsg={otpErrorMsg}
      />
    );
  }

  if (!interviewStarted) {
    return (
      <StartAssessmentPage
        interviewDetail={interviewDetail}
        agreed={agreed}
        setAgreed={setAgreed}
        canStartInterview={canStartInterview}
        countdownText={countdownText}
        onStart={handleStartTest}
        interviewStatus={interviewStatus}
      />
    );
  }

  return (
    <AssessmentPageWrapper>
      <AssessmentHeader
        currentQ={currentQ}
        globalTimeLeft={globalTimeLeft}
        formatTime={formatTime}
        localVideoRef={localVideoRef}
        onOpenGuidelines={() => setOpenGuidelinesDialog(true)}
      />

      <AssessmentBodyWrapper>
        <AssessmentQuestionSection
          questions={apiQuestions}
          currentQuestion={currentQuestion}
          savedQuestions={savedQuestions}
          onQuestionClick={handleQuestionClick}
        />

        <CodeEditorSection
          code={currentCode}
          language={currentQ?.programming_langauge || ""}
          onChange={handleCodeChange}
          onSave={handleSave}
          onPrevious={handlePrevious}
          onNext={handleNext}
          onSubmit={handleConfirmSubmit}
          isFirstQuestion={currentQuestion === 0}
          isLastQuestion={currentQuestion === apiQuestions.length - 1}
          isSaved={!!savedQuestions[currentQuestion]}
        />
      </AssessmentBodyWrapper>

      <GuidelinesDialogBox
        open={openGuidelinesDialog}
        onClose={() => setOpenGuidelinesDialog(false)}
      />

      <ConfirmSubmissionDialogBox
        open={openSubmitDialog}
        onClose={() => setOpenSubmitDialog(false)}
        onSubmit={handleSubmit}
        isLoading={isSubmitting}
      />

      <EnablingCameraMessageDialog open={showFaceDialog} message={faceMessage} />

      <InterviewFullScreenDilogue
        open={showFullScreenDialog}
        onEnterFullScreen={handleEnterFullScreen}
      />

      <Snackbar
        open={!!tabSwitchWarning}
        autoHideDuration={5000}
        onClose={() => setTabSwitchWarning("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setTabSwitchWarning("")}
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontWeight: 600, fontSize: "14px" }}
        >
          {tabSwitchWarning}
        </Alert>
      </Snackbar>
    </AssessmentPageWrapper>
  );
};

export default TechnicalAssessmentTest;
